import React, {Component} from 'react';

// Components
import {documentTypes} from "../common/document_types";

class DeleteSerieDialog extends Component {
    constructor(props) {
        super(props);

        const docType = documentTypes
            .filter(docType => docType.get('type') === this.props.serie.get('document_type'))
            .get(0)
            .get('desc')
        ;

        this.state = {
            docType
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    onDeleteButtonClick = () => {
        this.props.deleteSerie(this.props.serie.get('_id'));
        this.props.onCloseModal();
    };

    render() {
        return (
            <div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Tipo de documento</label>
                        <input
                            className="form-control"
                            type="text"
                            value={ this.state.docType }
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Nombre</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.props.serie.get('name')}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default DeleteSerieDialog;


// WEBPACK FOOTER //
// ./src/components/dialogs/DeleteSerieDialog.js